import { mutate } from 'swr'

import {
  fetchFile,
  postJson,
  putJson,
  requestDelete,
  requestDeleteBatchWithBody,
} from '../../../../../data/fetchers'
import {
  CustomFieldDefinition,
  MasterDataSupplier,
  SupplierCompanyCodeLink,
  SupplierCustomField,
} from './model'

// MasterData/CustomFieldDefinitions
// CustomFieldDefinitionRequest
export async function requestCreateCustomFieldDefinition(
  customFieldDefinition: CustomFieldDefinition,
) {
  await postJson(`/masterdata/customfielddefinitions`, customFieldDefinition)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/masterdata/customfielddefinitions`.toLowerCase()),
  )
}

export async function requestDeleteCustomFieldDefinition(id: string) {
  await requestDelete(`/masterdata/customfielddefinitions/${id}`)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith('/masterdata/customfielddefinitions'.toLowerCase()),
  )
}

// MasterData/SupplierCompanyCodes
export async function requestLinkSupplierCompanyCodes(
  link: SupplierCompanyCodeLink,
) {
  await postJson(`/masterdata/suppliercompanycodes/link`, link)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/masterdata/suppliercompanycodes/link`.toLowerCase()),
  )
}

export async function requestUnlinkSupplierCompanyCodes(
  unlink: SupplierCompanyCodeLink,
) {
  await postJson(`/masterdata/suppliercompanycodes/unlink`, unlink)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/masterdata/suppliercompanycodes/unlink`.toLowerCase()),
  )
}

// MasterData/Suppliers
export async function requestCreateSupplier(supplier: MasterDataSupplier) {
  await postJson('/masterdata/suppliers', supplier)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/masterdata/suppliers'.toLowerCase()),
  )
}

export async function requestUpdateSupplier(
  id: string,
  supplier: MasterDataSupplier, // SupplierMasterDataRequest
) {
  await putJson(`/masterdata/suppliers/${id}`, supplier)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/masterdata/suppliers'.toLowerCase()),
  )
}

export async function requestDeleteSupplier(id: string) {
  await requestDelete(`/masterdata/suppliers/${id}`)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/masterdata/suppliers'.toLowerCase()),
  )
}

export async function requestDeleteSuppliers(
  supplierIds: string[],
): Promise<any> {
  const result = await requestDeleteBatchWithBody(
    `/masterdata/suppliers/batch`,
    supplierIds,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/suppliers`.toLowerCase()),
  )

  return result
}

// MasterData/Suppliers/CustomFields
export async function requestCreateSupplierCustomField(
  supplierId: string,
  supplierCustomField: SupplierCustomField,
) {
  await postJson(
    `/masterdata/suppliers/${supplierId}/customfields`,
    supplierCustomField,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/masterdata/suppliers/${supplierId}/customfields`.toLowerCase(),
      ),
  )
}

export async function requestUpdateSupplierCustomField(
  supplierId: string,
  customFieldId: string,
  supplierCustomField: SupplierCustomField,
) {
  await putJson(
    `/masterdata/suppliers/${supplierId}/customfields/${customFieldId}`,
    supplierCustomField,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/masterdata/suppliers/${supplierId}/customfields`.toLowerCase(),
      ),
  )
}

export async function requestDeleteSupplierCustomField(
  supplierId: string,
  customFieldId: string,
) {
  await requestDelete(
    `/masterdata/suppliers/${supplierId}/customfields/${customFieldId}`,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/masterdata/suppliers/${supplierId}/customfields`.toLowerCase(),
      ),
  )
}

export async function requestDownloadSuppliers(culture: string = 'DE-de') {
  const url = `/masterdata/suppliers/$download?csvCulture=${culture}`

  return await fetchFile(url)
}

export async function requestPrepareUploadableSuppliers(
  suppliersCsv: File,
  companyCodesRefsCsv: File,
  culture: string,
): Promise<MasterDataSupplier[]> {
  const formData = new FormData()
  formData.append('suppliers', suppliersCsv)
  formData.append('companyCodesRefs', companyCodesRefsCsv)

  const result = await postJson(
    `/masterdata/suppliers/batch/$preparecsv?csvCulture=${culture}`,
    formData,
  )

  return result as MasterDataSupplier[]
}

export async function requestUploadSuppliers(
  suppliers: MasterDataSupplier[],
  deleteExistingSuppliers: boolean = false,
): Promise<void> {
  let query = `?deleteExistingSuppliers=${deleteExistingSuppliers.toString()}`

  const result = await postJson(
    `/masterdata/suppliers/batch${query}`,
    suppliers,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/suppliers`.toLowerCase()),
  )

  return result
}
